<template>
  <div class="wechatPage">
    <p style="font-size: 12px">正在登录中，请稍候...</p>
  </div>
</template>

<script>
import { joinUrl } from '@yxcx/util'
import { MessageBox } from 'mint-ui'
import Service from '@svc/wechat'
import LoginService from '@svc/login'
import account from '@lib/account'
import clientInfo from '@util/x-client-info'
import { jump } from '@util/function'
import { getCustomerType, isNextMall } from '@util/mall-config'
import setDocumentTitle from '@util/document-title'

export default {
  async mounted() {
    setDocumentTitle('正在登录中...')
    console.log('index===$route', JSON.stringify(this.$route.query))
    const { code, cburi, mallcode } = this.$route.query || {}
    const cb = decodeURIComponent(cburi || '')

    //做code & cb 合法性校验
    if (!code) {
      return (window.location.href = decodeURIComponent(cb))
    }

    try {
      const { customerInfo, mallConfig } = await LoginService.getAllConfigInfo({ code: mallcode })
      clientInfo.setInfo({
        o: `${customerInfo.operatorId}`,
      })
      await this.getAutoLogin(code, mallcode, cb, mallConfig)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    async getAutoLogin(code, mallCode, cb, mallConfig) {
      const data = { code, mallCode }
      try {
        const res = await Service.wechatAutoLogin(data)
        const { isRegistered, loginToken } = res
        console.log('res-----', JSON.stringify(res))
        if (isRegistered) {
          // 已注册，保存登录信息，跳转首页
          account.setLoginSuccessData(res)
          jump({ url: cb })
        } else {
          // 清除登录信息
          account.logout()
          // 未注册
          const path = isNextMall(getCustomerType(mallConfig)) ? '/login/open' : '/login'
          const url = joinUrl(path, {
            code: mallCode,
            redirectUri: decodeURIComponent(cb),
            loginToken,
          })
          window.location.replace(url)
        }
      } catch (err) {
        console.error(err)
        MessageBox({
          title: '',
          message: err.msg || '服务器开小差~请稍后再试',
          showCancelButton: false,
        }).then((action) => {
          if (action != 'cancel') {
            this.toErrorPage()
          }
        })
      }
    },
    toErrorPage() {
      this.$router.push({
        name: 'tips',
      })
    },
    async getCustomerInfo(code) {
      return await LoginService.getAllConfigInfo(code)
    },
  },
}
</script>
<style lang="less" scoped>
.wechatPage {
  display: block;
  margin: 8px;
  font-size: 12px;

  p {
    margin: 0;
    padding: 0.2em 0;
  }
}
</style>
